/* eslint-disable react/prop-types */
import React, { Component } from 'react'
import styled from 'styled-components'
import shortid from 'shortid'
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  CustomInput,
  Button as BaseButton,
} from 'reactstrap'

import { FONTS, COLORS } from '../../constants'

const range = (from, to) => {
  const result = []
  for (let i = from; i <= to; i++) {
    result.push(i)
  }
  return result
}

const $thisYear = () => new Date().getFullYear()

const Typography = {
  Header: styled.p`
    margin: 0px;

    position: relative;
    top: 4px;

    color: ${COLORS.PRIMARY_RED};
    font-family: ${FONTS.GOTHAM_MEDIUM} !important;
    font-size: ${FONTS.TITLE_SIZE};
  `,
}

const Button = styled(BaseButton)`
  width: fit-content;
  height: 40px;
  padding-top: 0px;
  padding-bottom: 0px;

  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.NORMAL_SIZE};
`

const Select = styled(CustomInput).attrs({ type: 'select' })`
  width: 100%;
  height: 100%;

  font-family: ${FONTS.GOTHAM} !important;
  font-size: ${FONTS.NORMAL_SIZE};
`

/**
 * @typedef {object} Props
 * @property {boolean} isOpen
 * @property {function} toggle
 * @property {function} exportMethod
 */

/** @extends {Component<Props, *>} */
class ExportModal extends Component {
  state = {
    year: $thisYear(),
  }

  changeYear = e => this.setState({ year: e.target.value })

  from2018toPresent = () =>
    range(2018, $thisYear()).map(y => (
      <option value={ String(y) } key={ shortid.generate() }>
        {y}
      </option>
    ))

  handleExport = () => {
    this.props.exportMethod(this.state.year)
    this.props.toggle()
  }

  render = () => {
    const { props } = this
    return (
      <Modal isOpen={ props.isOpen } toggle={ props.toggle }>
        <ModalHeader toggle={ props.toggle }>
          <Typography.Header>Export Leave Generation</Typography.Header>
        </ModalHeader>
        <ModalBody>
          <Select
            id="lg_export_year"
            name="lg_export_year"
            value={ this.state.year }
            onChange={ this.changeYear }
          >
            {this.from2018toPresent().reverse()}
          </Select>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={ this.handleExport }>
            Export
          </Button>
        </ModalFooter>
      </Modal>
    )
  }
}

export default ExportModal



// WEBPACK FOOTER //
// ./src/components/leave-generation/ExportModal.jsx